<div class="doc-upload-actions" *ngIf="showBegin && showBackButton">
    <button mat-button class="secondary" (click)="return()">Back to Documents</button>
</div>
<div class="upload-card" [ngClass]="{ hidden: !showBegin }">
    <mat-card>
        <div class="upload-card-body">
            <h2>Facial Recognition</h2>
            <p>
                You will be asked to take a selfie using your mobile device. This will verify that your likeness matches your driver's license, and that you are
                taking a live image. Follow the instructions on the screen.
            </p>
            <p>Note: Please make sure you are in a very well-lit area.</p>
            <div class="upload-card-actions pdf-column">
                <button class="mobile-view-btn" mat-button type="button" (click)="startCapture()" id="idn-facial-recognition-start-button">Take Selfie</button>
                <input #manualInput type="file" accept="image/*" style="display: none" capture="user" (change)="onImageCapture($event.target['files'][0])" />
            </div>
        </div>
    </mat-card>
</div>

<div [ngClass]="{ hidden: !showPreview }" class="single-upload-preview-wrapper">
    <div class="upload-actions">
        <button mat-button type="button" class="primary" (click)="continue()">Continue</button>
        <button class="secondary" mat-button type="button" (click)="recapture()">Retake</button>
    </div>
    <div class="single-upload-preview-image-wrapper">
        <canvas #uploadPreview id="barcodeUploadPreview"> </canvas>
    </div>
</div>
